import React from 'react';

const employees = [
  {
    id: 1,
    name: 'Бат-Эрдэнэ',
    position: 'Засварчин',
    photo: '/uploads/employees/bat-erdene.jpg',
    phone: '99112233',
    email: 'bat@khuleg.mn'
  },
  {
    id: 2,
    name: 'Сараа',
    position: 'Менежер',
    photo: '/uploads/employees/saraa.jpg',
    phone: '99114455',
    email: 'saraa@khuleg.mn'
  }
  // ... бусад ажилчид
];

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEmployees = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get('/admin/users');
        // Зөвхөн employee role-той хэрэглэгчдийг шүүнэ
        const items = Array.isArray(res.data.items) ? res.data.items : [];
        setEmployees(items.filter(u => u.role === 'employee'));
      } catch (err) {
        setError(err.response?.data?.message || 'Ажилчид авах үед алдаа гарлаа');
      } finally {
        setLoading(false);
      }
    };
    fetchEmployees();
  }, []);

  return (
    <div>
      <h2>Ажилчдын бүртгэл</h2>
      {loading && <div>Ачааллаж байна...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div className="employee-list-grid">
        {employees.length === 0 && !loading && !error && (
          <div>Ажилтан бүртгэгдээгүй байна.</div>
        )}
        {employees.map(emp => (
          <div key={emp._id} className="employee-list-card">
            <img
              src={emp.photo || '/uploads/employees/default.jpg'}
              alt={emp.username || emp.name || 'Ажилтан'}
              className="employee-list-photo"
              onError={e => { e.target.onerror = null; e.target.src = '/uploads/employees/default.jpg'; }}
            />
            <div className="employee-list-name">{emp.username || emp.name || '-'}</div>
            <div className="employee-list-position">{emp.position || '-'}</div>
            <div className="employee-list-contact">{emp.phone || '-'}</div>
            <div className="employee-list-contact">{emp.email || '-'}</div>
          </div>
        ))}
        <style>{`
          .employee-list-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
            gap: 18px;
            margin-top: 8px;
          }
          .employee-list-card {
            border: 1px solid #eee;
            border-radius: 10px;
            padding: 16px;
            background: #fafbfc;
            min-width: 0;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .employee-list-photo {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            object-fit: cover;
            margin-bottom: 12px;
          }
          .employee-list-name {
            font-weight: 700;
            margin-bottom: 2px;
          }
          .employee-list-position {
            margin-bottom: 2px;
          }
          .employee-list-contact {
            font-size: 13px;
            color: #888;
          }
          @media (max-width: 600px) {
            .employee-list-grid {
              grid-template-columns: 1fr;
              gap: 12px;
            }
            .employee-list-card {
              padding: 12px;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default EmployeeList;
